import { render } from "./ChangePhotoOnFront.vue?vue&type=template&id=7f98454a&scoped=true"
import script from "./ChangePhotoOnFront.vue?vue&type=script&lang=js"
export * from "./ChangePhotoOnFront.vue?vue&type=script&lang=js"

import "./ChangePhotoOnFront.vue?vue&type=style&index=0&id=7f98454a&scoped=true&lang=css"
import "./ChangePhotoOnFront.vue?vue&type=style&index=1&id=7f98454a&scoped=true&lang=css"
import "./ChangePhotoOnFront.vue?vue&type=style&index=2&id=7f98454a&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f98454a"]])

export default __exports__